import axios from 'axios';
import strings from './String';

const axiosPythiaInstance = axios.create({
  baseURL: strings.pythiaApiBaseUrl,
  withCredentials: true
});

axiosPythiaInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosPythiaInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          break;
        case 500:
          break;
        default:
          break;
      }
    } else if (error.request) {
      console.error('No response received');
    } else {
      console.error('Request error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosPythiaInstance;
